import baseApi from 'api/baseApi';
import { INamedEntity } from 'common/interfaces/common';
import { IPaginatedData } from 'common/interfaces/pagination';

const referralApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getReferralLeads: builder.query<IPaginatedData<INamedEntity>, { search: string; page: number }>(
      {
        query: ({ search, page }) => ({
          url: '/api/v1/leads/referrals/list',
          method: 'GET',
          params: { search, page, perPage: 30 },
        }),
      },
    ),
    getReferralPTLeads: builder.query<
      IPaginatedData<INamedEntity>,
      { search: string; page: number }
    >({
      query: ({ search, page }) => ({
        url: '/api/v1/pt-leads/referrals/list',
        method: 'GET',
        params: { search, page, perPage: 30 },
      }),
    }),
    getReferralMembers: builder.query<
      IPaginatedData<INamedEntity>,
      { search: string; page: number }
    >({
      query: ({ search, page }) => ({
        url: '/api/v1/members/referrals/list',
        method: 'GET',
        params: { search, page, perPage: 30 },
      }),
    }),
    getPersonReferralMembers: builder.query<
      IPaginatedData<INamedEntity>,
      { search: string; page: number; personId: number }
    >({
      query: ({ search, page, personId }) => ({
        url: `/api/v1/front-desk/${personId}/referrals/list`,
        method: 'GET',
        params: { search, page, perPage: 30 },
      }),
    }),
    getFrontDeskReferralMembers: builder.query<
      IPaginatedData<INamedEntity>,
      { search: string; page: number }
    >({
      query: ({ search, page }) => ({
        url: '/api/v1/front-desk/referrals/list',
        method: 'GET',
        params: { search, page, perPage: 30 },
      }),
    }),
    getCampaignReferralMembers: builder.query<
      IPaginatedData<INamedEntity>,
      { search: string; page: number }
    >({
      query: ({ search, page }) => ({
        url: '/api/v1/campaign/referrals/list',
        method: 'GET',
        params: { search, page, perPage: 30 },
      }),
    }),
    getPTCampaignReferralMembers: builder.query<
      IPaginatedData<INamedEntity>,
      { search: string; page: number }
    >({
      query: ({ search, page }) => ({
        url: '/api/v1/pt-campaign/referrals/list',
        method: 'GET',
        params: { search, page, perPage: 30 },
      }),
    }),
  }),
});

export const {
  useLazyGetReferralMembersQuery: useLazyGetReferralMembers,
  useLazyGetFrontDeskReferralMembersQuery: useLazyGetFrontDeskReferralMembers,
  useLazyGetReferralLeadsQuery: useLazyGetReferralLeads,
  useLazyGetPersonReferralMembersQuery: useLazyGetPersonReferralMembers,
  useLazyGetReferralPTLeadsQuery: useLazyGetReferralPTLeads,
  useLazyGetCampaignReferralMembersQuery: useLazyGetCampaignReferralMembers,
  useLazyGetPTCampaignReferralMembersQuery: useLazyGetPTCampaignReferralMembers,
} = referralApi;

export default referralApi;
